import React from "react";
import {GoogleMapLoader, GoogleMap, Marker} from "react-google-maps";
import {markers} from "../../libs/config";
import LeafletMap from "../common/LeafletMap";

class StationSpecificMap extends React.Component {

  render() {
    const {station} = this.props;

    return(
      <div>
        <LeafletMap id={`station_map-${station.id}`} markers={[station]} center={station.position} zoom={8} height='200px'/>
      </div>
    );

    // return (
    //   <div>
    //     <GoogleMapLoader
    //       containerElement={<div {...this.props} style={{
    //         top: '0px',
    //         height: '200px',
    //         width: 'inherit'
    //       }}/>}
    //       googleMapElement={
    //         <GoogleMap center={station.position} defaultZoom={8} ref="map">
    //           <Marker ref={station.id} icon={station.icon || markers.blue_marker} position={station.position} />
    //         </GoogleMap>}
    //     />
    //   </div>
    // );
  }

}

export default StationSpecificMap;






// WEBPACK FOOTER //
// ./src/components/Station/StationSpecificMap.js